import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import Modal, { ModalContent, ModalHeader } from '../components/HOC/Modal';
import { useAppModals, useWidgetState } from './WidgetsContext';

// Moderation reporting is only reachable from a signed-in menu, so it has no
// business in the root Provider chunk an anonymous visitor downloads.
const ReportModal = dynamic(() => import('../components/moderation/ReportModal'), {
  ssr: false
});

// Stripe-using modules are deferred — they pull `@stripe/stripe-js` which
// otherwise loads Stripe.js (and sets the m.stripe.com fraud cookie) on
// every page via the global Provider tree.
const PurchaseModal = dynamic(() => import('../components/common/PurchaseModal'), {
  ssr: false
});
const FoundersToken = dynamic(() => import('../components/products/FoundersToken').then(m => m.FoundersToken), {
  ssr: false
});
const AppWidgets = () => {
  const $ = _c(13);
  const {
    moderationReport,
    purchaseModal,
    foundersTokenModalOpen
  } = useWidgetState();
  const {
    closeNewModerationReportModal,
    setPurchaseModal,
    dismissFoundersTokenModal
  } = useAppModals();
  let t0;
  if ($[0] !== closeNewModerationReportModal || $[1] !== moderationReport) {
    t0 = moderationReport && <ReportModal closeHandler={closeNewModerationReportModal} moderationType={moderationReport.type} target={moderationReport.target} />;
    $[0] = closeNewModerationReportModal;
    $[1] = moderationReport;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== purchaseModal || $[4] !== setPurchaseModal) {
    t1 = purchaseModal?.isOpen === true && purchaseModal.product && <PurchaseModal product={purchaseModal.product} closeHandler={() => setPurchaseModal(false, null)} />;
    $[3] = purchaseModal;
    $[4] = setPurchaseModal;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== dismissFoundersTokenModal || $[7] !== foundersTokenModalOpen) {
    t2 = foundersTokenModalOpen && <Modal closeHandler={dismissFoundersTokenModal}><ModalHeader closeHandler={dismissFoundersTokenModal}><h2 className="text-xl font-semibold">Limited Time: Founders Token Sale</h2></ModalHeader><ModalContent><div className="max-h-96 overflow-y-auto"><FoundersToken /></div></ModalContent></Modal>;
    $[6] = dismissFoundersTokenModal;
    $[7] = foundersTokenModalOpen;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default AppWidgets;